<template>
    <div>
        <el-dialog
            :visible.sync="FuLiFormVisible"
            :append-to-body="true"
            width="1000px"
            :center="true"
            top="10px"
            :close-on-click-modal="false"
            :before-close="() => closeFuLiFormDialog('FuLiForm')"
            v-loading.fullscreen.lock="login_loading"
        >
            <div>
                <el-form
                    :model="FuLiForm"
                    ref="FuLiForm"
                    label-width="100px"
                    size="small"
                >
                    <div>
                        <el-descriptions
                            class="margin-top"
                            :column="1"
                            :labelStyle="{'width':'120px','text-align':'center'}"
                            :contentStyle="{'text-align': 'center'}"
                            border
                        >
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>标题</span>
                                </template>
                                <el-input
                                    v-model="FuLiForm.title"
                                    :maxlength="50"
                                    show-word-limit
                                    clearable
                                    style="font-family: HarmonyOS_Sans_Black;font-weight: bold;"
                                ></el-input>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>类型</span>
                                </template>
                                <el-radio-group v-model="FuLiForm.fuli_type" @change="fuli_type_change">
                                    <el-radio-button :label="1">发积分</el-radio-button>
                                    <el-radio-button :label="2">发奖券</el-radio-button>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item v-if="FuLiForm.fuli_type===1">
                                <template slot="label">
                                    <span>数量</span>
                                </template>
                                <el-radio-group v-model="FuLiForm.fuli_num">
                                    <el-radio-button :label="100">100积分</el-radio-button>
                                    <el-radio-button :label="200">200积分</el-radio-button>
                                    <el-radio-button :label="500">500积分</el-radio-button>
                                    <el-radio-button :label="1000">1000积分</el-radio-button>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item v-if="FuLiForm.fuli_type===2">
                                <template slot="label">
                                    <span>数量</span>
                                </template>
                                <el-radio-group v-model="FuLiForm.fuli_num">
                                    <el-radio-button :label="20">20个</el-radio-button>
                                    <el-radio-button :label="60">60个</el-radio-button>
                                    <el-radio-button :label="100">100个</el-radio-button>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>人数</span>
                                </template>
                                <el-radio-group v-model="FuLiForm.fuli_renshu">
                                    <el-radio-button :label="10">10人</el-radio-button>
                                    <el-radio-button :label="20">20人</el-radio-button>
                                </el-radio-group>
                            </el-descriptions-item>
                            <el-descriptions-item>
                                <template slot="label">
                                    <span>方式</span>
                                </template>
                                <el-radio-group v-model="FuLiForm.fuli_fangshi">
                                    <el-radio-button :label="1">拼手气</el-radio-button>
                                    <el-radio-button :label="2">平分</el-radio-button>
                                </el-radio-group>
                            </el-descriptions-item>
                        </el-descriptions>
                    </div>
                </el-form>
            </div>
            <div slot="footer" class="dialog-footer">
                <el-button
                    v-if="edit_type"
                    type="primary"
                    plain
                    @click="submitEdit('FuLiForm')"
                    >修改</el-button
                >
                <el-button
                    v-else
                    type="success"
                    plain
                    @click="submitInsert('FuLiForm')"
                    >发布</el-button
                >
                <el-button
                    plain
                    @click="closeFuLiFormDialog('FuLiForm')"
                    >关闭</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>

<script>

import { ForumAddRequest,ForumEditRequest } from '@/network/forum.js'

export default {
    name: 'ForumFuLiComponent',
    data() {
        return {
            login_loading: false,
            FuLiForm: {
                type: '',
                title: '',
                content: 1,
                fuli_type: '',
                fuli_num: '',
                fuli_renshu: '',
                fuli_fangshi: ''
            }
        }
    },
    computed: {},
    methods: {
        closeFuLiFormDialog(formName) {
            this.FuLiForm = {
                type: '',
                title: '',
                content: 1,
                fuli_type: '',
                fuli_num: '',
                fuli_renshu: '',
                fuli_fangshi: ''
            }
            this.$emit('exitFuLiFormDialog')
        },
        submitInsert(formName) {
            this.login_loading = true
            this.FuLiForm.type = this.type
            ForumAddRequest(this.FuLiForm)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('添加成功!')
                        this.closeFuLiFormDialog()
                        this.$emit('exitFuLiFormDialog')
                        this.$emit('search')
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        submitEdit(formName) {
            this.login_loading = true
            ForumEditRequest(this.FuLiForm)
                .then((s) => {
                    this.login_loading = false
                    if (s.status === 0) {
                        this.$message.success('修改成功!')
                        this.closeFuLiFormDialog()
                        this.$emit('exitFuLiFormDialog')
                        this.$emit('search')
                    } else {
                        this.$message.error(s.msg)
                    }
                })
                .catch((err) => {
                    this.login_loading = false
                    this.$message.error(err)
                })
        },
        fuli_type_change() {
            this.FuLiForm.fuli_num = ''
            this.FuLiForm.fuli_renshu = ''
            this.FuLiForm.fuli_fangshi = ''
        }
    },
    filters: {},
    props: {
        FuLiFormVisible: Boolean,
        type: {
            type: Number | String,
            default() {
                return ''
            }
        },
        details_data: {
            type: Object,
            default() {
                return {}
            }
        },
        edit_type: {
            type: Number,
            default() {
                return 0
            }
        }
    },
    created() {},
    destoryed() {},
    mounted() {},
    updated() {},
    components: {},
    watch: {
        type(newVal) {
            this.FuLiForm.type = newVal
        },
        edit_type(newVal) {
            if(newVal) {
                this.FuLiForm = {
                    id: this.details_data.id,
                    type: this.details_data.type,
                    title: this.details_data.title,
                    content: this.details_data.content,
                    fuli_type: this.details_data.fuli_type,
                    fuli_num: this.details_data.fuli_num,
                    fuli_renshu: this.details_data.fuli_renshu,
                    fuli_fangshi: this.details_data.fuli_fangshi
                }
            } else {
                this.FuLiForm = {
                    type: '',
                    title: '',
                    content: 1,
                    fuli_type: '',
                    fuli_num: '',
                    fuli_renshu: '',
                    fuli_fangshi: ''
                }
            }
        }
    },
}
</script>

<style lang='less' scoped></style>